import { apiClient } from '@/api/client'
import type { LyricsExtractResponse, LyricsSaveRequest, LyricsSaveResponse } from '@/api/types/lyrics'

/** 歌詞ページの URL から歌詞候補を AI で抽出する（保存はしない） */
export const extractEpisodeLyrics = async (episodeId: number, url: string): Promise<LyricsExtractResponse> => {
  const res = await apiClient.post<LyricsExtractResponse>(`/e/${episodeId}/lyrics/extract`, { url })
  return res.data
}

/** 歌詞テキストを保存する */
export const saveEpisodeLyrics = async (episodeId: number, body: LyricsSaveRequest): Promise<LyricsSaveResponse> => {
  const res = await apiClient.put<LyricsSaveResponse>(`/e/${episodeId}/lyrics`, body)
  return res.data
}
